import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { URL } from "../../api";
import axiosInstance from "../../Request";

const CreateUser = () => {
  const [userData, setUserData] = useState({
    name: "",
    username: "",
    password: "",
    email: "",
    phone: "",
    department: "",
    groupId: "",
    isActive: true,
    isAdmin: false,
  });

  const [document, setDocument] = useState(null);
  const [userList, setUserList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedPrivilegeUserId, setSelectedPrivilegeUserId] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [isPasswordTouched, setIsPasswordTouched] = useState(false);

 useEffect(() => {
  const fetchUsers = async () => {
    try {
      const res = await axiosInstance.get(URL.GET_USER_LIST);
      const data = res.data;
      setUserList(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };
  fetchUsers();
}, []);

  const fetchUserDetailsById = async (userId) => {
  try {
    const res = await axiosInstance.get(`${URL.USER_DATA_FILL}?user_id=${userId}`);
    const data = res.data;
    if (res.status === 200 && data) {
      setUserData({
        name: data.name || "",
        username: data.user_name || "",
        password: "*********", // Show masked initially
        email: data.email || "",
        phone: data.phoneNumber || "",
        department: data.dept || "",
        groupId: data.groupId || "",
        isActive: data.isActive || false,
        isAdmin: data.admin || false,
      });
      setIsEditMode(true);
      setIsPasswordTouched(false); // reset password field touch
    } else {
      alert("Failed to fetch user data");
    }
  } catch (err) {
    console.error("Error fetching user by ID:", err);
  }
};
  const handleUserChange = (e) => {
    const userId = e.target.value;
    setSelectedUserId(userId);
    if (userId) {
      fetchUserDetailsById(userId);
    } else {
      setIsEditMode(false);
      setUserData({
        name: "",
        username: "",
        password: "",
        email: "",
        phone: "",
        department: "",
        groupId: "",
        isActive: true,
        isAdmin: false,
      });
    }
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    setUserData((prev) => ({ ...prev, [name]: val }));
  };

  const handleFileChange = (e) => {
    setDocument(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

try {
  let res, result;

  if (isEditMode) {
    const payload = {
      userId: selectedUserId,
      name: userData.name,
      user_name: userData.username,
      password:
        userData.password !== "*********" ? userData.password : undefined,
      email: userData.email,
      phoneNumber: userData.phone,
      dept: userData.department,
      groupId: userData.groupId,
      isActive: userData.isActive ? 1 : 0,
      admin: userData.isAdmin ? 1 : 0,
    };

    res = await axiosInstance.post(URL.USER_DATA_UPDATE, payload, {
      withCredentials: true,
    });
  } else {
    const formData = new FormData();
    formData.append("name", userData.name);
    formData.append("user_name", userData.username);
    formData.append("email", userData.email);
    formData.append("password", userData.password);
    formData.append("phoneNumber", userData.phone);
    formData.append("dept", userData.department);
    formData.append("groupId", userData.groupId);
    formData.append("isActive", userData.isActive ? 1 : 0);
    formData.append("admin", userData.isAdmin ? 1 : 0);
    if (selectedPrivilegeUserId) {
      formData.append("fromUserId", selectedPrivilegeUserId);
    }
    if (document) {
      formData.append("document", document);
    }

   res = await axiosInstance.post(URL.USER_CREATE, formData, {
  headers: {
    "Content-Type": "multipart/form-data", // ✅ Override only here
  },
  withCredentials: true,
});
  }

  result = res.data;

  if (res.status === 200) {
    alert(result.message || (isEditMode ? "User updated" : "User created"));
    if (!isEditMode) {
      window.location.reload(); // Refresh page only after user creation
    } else {
      setUserData({
        name: "",
        username: "",
        password: "",
        email: "",
        phone: "",
        department: "",
        groupId: "",
        isActive: true,
        isAdmin: false,
      });
      setSelectedUserId("");
      setSelectedPrivilegeUserId("");
      setIsEditMode(false);
      setIsPasswordTouched(false);
      setDocument(null);
    }
  } else {
    alert(result.message || "Failed to submit user data");
  }
} catch (err) {
  console.error(err);
  alert("An error occurred");
}
  };

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-4 pt-md-7" />
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <Col xl="12">
            <Card className="shadow">
              <CardHeader className="border-0 mx-4">
                <Row className="align-items-center">
                  <Col xl="9">
                    <h3 className="mb-0">
                      {isEditMode ? "Update User" : "Create New User"}
                    </h3>
                  </Col>
                  <Col xl="3">
                    <Input
                      type="select"
                      value={selectedUserId}
                      onChange={handleUserChange}
                    >
                      <option value="">--Select User--</option>
                      {userList.map((user) => (
                        <option key={user.id} value={user.id}>
                          {user.user_name} -- {user.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="mx-4">
                <Form onSubmit={handleSubmit}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="name">
                      Name
                    </label>
                    <Input
                      className="form-control-alternative"
                      type="text"
                      name="name"
                      id="name"
                      autoComplete="new-password"
                      value={userData.name}
                      onChange={handleChange}
                      required
                      disabled={isEditMode}
                    />
                  </FormGroup>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="username">
                          Username
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          name="username"
                          id="username"
                          autoComplete="new-password"
                          value={userData.username}
                          onChange={handleChange}
                          required
                          disabled={isEditMode}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="password">
                          Password
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="password"
                          name="password"
                          id="password"
                          autoComplete="new-password"
                          value={
                            isEditMode && !isPasswordTouched
                              ? "*********"
                              : userData.password
                          }
                          onChange={(e) => {
                            setUserData((prev) => ({
                              ...prev,
                              password: e.target.value,
                            }));
                          }}
                          onFocus={() => {
                            if (!isPasswordTouched) {
                              setUserData((prev) => ({ ...prev, password: "" }));
                              setIsPasswordTouched(true);
                            }
                          }}
                          required={!isEditMode}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="phone">
                          Phone Number
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="tel"
                          name="phone"
                          id="phone"
                          value={userData.phone}
                          onChange={handleChange}
                          disabled={isEditMode}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="email">
                          Email address
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="email"
                          name="email"
                          id="email"
                          value={userData.email}
                          onChange={handleChange}
                          required
                          disabled={isEditMode}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="department">
                          Department
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          name="department"
                          id="department"
                          value={userData.department}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="groupId">
                          Group Id
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          name="groupId"
                          id="groupId"
                          value={userData.groupId}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {!isEditMode && (
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="privilege">
                            Privilege
                          </label>
                          <Input
                            type="select"
                            id="privilege"
                            className="form-control-alternative"
                            value={selectedPrivilegeUserId}
                            onChange={(e) => setSelectedPrivilegeUserId(e.target.value)}
                            required
                          >
                            <option value="">-- Select User --</option>
                            {userList.map((user) => (
                              <option key={user.id} value={user.id}>
                                {user.user_name} - {user.group_id}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  )}

                  <Row className="md-3">
                    <Col xs="auto" className="me-4">
                      <FormGroup check className="mb-3">
                        <Label check>
                          <Input
                            className="form-check-input form-control-alternative"
                            type="checkbox"
                            name="isActive"
                            checked={userData.isActive}
                            onChange={handleChange}
                          />
                          Active
                        </Label>
                      </FormGroup>
                    </Col>
                    {!isEditMode && (
                      <Col xs="auto">
                        <FormGroup check className="mb-3">
                          <Label check>
                            <Input
                              className="form-check-input form-control-alternative"
                              type="checkbox"
                              name="isAdmin"
                              checked={userData.isAdmin}
                              onChange={handleChange}
                            />
                            Admin
                          </Label>
                        </FormGroup>
                      </Col>
                    )}
                  </Row>

                  <FormGroup>
                    <label className="form-control-label">User Document</label>
                    <Input
                      type="file"
                      name="document"
                      id="document"
                      onChange={handleFileChange}
                    />
                  </FormGroup>

                  <Button color="primary" type="submit">
                    {isEditMode ? "Update User" : "Create User"}
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateUser;

